export const PF_SORT_ASCENDING = "asc";
export const PF_SORT_DESCENDING = "desc";
export const PF_SORT_FEATURED = "featured";
